/** @format */

import React, { useEffect, useRef, useState } from 'react';
import { FilterPod, TableReport, SimpleDialog, ReceiveFile } from 'components';
import { toFilterVOS } from 'components/FilterPod';
import { enifyDateTime } from 'utility';
import { Grid, Box } from '@mui/material';
import createToast from 'components/Toast/Toast';
import { useCategoryList } from './components/useCategoryList';
import { DelegationDetails, DetailPanel, TransferDelegation } from './components';
import AssignedDelegationServices from './services/ReceivedDelegationServices';
import { columns, generateData } from './components/Columns';
import { putDefaultList } from './services/ReceivedDelegationServices';
import { useStyles } from '../../style';
import useCustomHook from './hooks';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction } from 'utility';
import axios from 'axios';

// TODO: Detail button is not responsive
// TODO: Some Transfer Button should be disabled as condition
export const ReceivedDelegationReport = ({ businessInfo, currencyText }) => {
  // -- STATES --//
  const {
    loading,
    setLoading,
    filterParams,
    setFilterParams,
    page,
    setPage,
    size,
    setSize,
    activeDetailID,
    setActiveDetailID,
    filters,
    setFilters,
    isTransferOpen,
    setIsTransferOpen,
    targetTransferDelegation,
    setTargetTransferDelegation,
    emptyLabel,
    setEmptyLabel,
    dataDialog,
    setDataDialog,
    showDialog,
    setShowDialog,
    paramsData,
    setParamsData,
  } = useCustomHook(currencyText);

  const { categoryList, getCategoryList } = useCategoryList();

  // --HOOKS--//
  const classes = useStyles();
  const tableRef = useRef(null);
  let actionsList = getDynamicObjectAction([
    'selfAccountDelegationPage',
    'exportAccountDelegationBtn',
    'transferAccountDelegationBtn',
    'defaultAccountDelegationBtn',
    'detailAccountDelegationBtn',
  ]);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  useEffect(() => {
    getCategoryList();
  }, []);

  useEffect(() => {
    if (categoryList?.length === 0) return;
    setFilters((currentFilters) => {
      const periodFilterIndex = currentFilters.findIndex((filter) => filter?.keyName === 'periodId');

      if (periodFilterIndex < 0) return currentFilters;

      const nextFilters = [...currentFilters];
      nextFilters[periodFilterIndex] = {
        ...nextFilters[periodFilterIndex],
        filterProps: {
          ...nextFilters[periodFilterIndex]?.filterProps,
          options: categoryList,
        },
      };

      return nextFilters;
    });
  }, [categoryList]);

  const getDelegations = async (query) => {
    try {
      setLoading(true);

      // Handle Order By
      let orderBy = [];
      let orderByName = null;

      switch (query?.orderBy?.title) {
        case 'تخصیص‌دهنده':
          orderByName = 'نام و نام خانوادگی کاربر تخصیص دهنده';
          break;
        case `به میزان - ${currencyText}`:
          orderByName = 'میزان';
          break;
        case `میزان مصرف - ${currencyText}`:
          orderByName = 'استفاده شده';
          break;
        case 'شروع':
          orderByName = 'زمان شروع';
          break;
        case 'انقضا':
          orderByName = 'زمان انقضا';
          break;
        case 'شارژ مجدد':
          orderBy = [
            {
              name: 'دوره',
              isDesc: query?.orderDirection === 'desc',
            },
            {
              name: 'تعداد شارژ مجدد',
              isDesc: query?.orderDirection === 'desc',
            },
          ];
          break;
        case 'وضعیت':
          orderByName = query?.orderBy?.title;
          break;

        default:
          break;
      }
      if (orderByName && orderBy.length === 0) {
        orderBy = [
          {
            name: orderByName,
            isDesc: query?.orderDirection === 'desc',
          },
        ];
      }

      const filter = toFilterVOS([...filters]);
      setEmptyLabel(
        filter.length > 0 ? 'داده‌ای یافت نشد!' : 'در بازه زمانی موردنظر داده‌ای یافت نشد!',
      );

      const params = {
        size: query?.pageSize || size,
        page: query ? query?.pageNumber : page,
        startDate: filters.find((a) => a.keyName === 'dateRange')?.value?.start
          ? enifyDateTime(
              filters.find((a) => a.keyName === 'dateRange').value?.start?.format('jYYYY/jMM/jDD'),
            )
          : null,
        endDate: filters.find((a) => a.keyName === 'dateRange')?.value?.end
          ? enifyDateTime(
              filters.find((a) => a.keyName === 'dateRange').value?.end?.format('jYYYY/jMM/jDD'),
            )
          : null,
        minAmountLimit: filters.find((a) => a.keyName === 'amountRange').value.start || null,
        maxAmountLimit: filters.find((a) => a.keyName === 'amountRange').value.end || null,
        minUseAmountLimit: filters.find((a) => a.keyName === 'usedRange').value.start || null,
        maxUseAmountLimit: filters.find((a) => a.keyName === 'usedRange').value.end || null,
        dateType:
          filters.find((a) => a.keyName === 'dateRange')?.value?.start &&
          filters.find((a) => a.keyName === 'dateRange')?.value?.end
            ? filters.find((f) => f.keyName === 'dateType').value
            : null,
        periodId: filters.find((a) => a.keyName === 'periodId')?.value || null,
        creditId: filters.find((a) => a.keyName === 'creditId')?.value || null,
        activeStatus: filters.find((a) => a.keyName === 'activeStatus')?.value || null,
        userId: businessInfo?.userId,
        ownerUserId: filters.find((a) => a.keyName === 'ownerUserId')?.value || null,
      };

      setParamsData({ ...params });

      setFilterParams({ params });

      const res = await AssignedDelegationServices.getDelegationReport(params);

      let list = [];
      if (res.result?.length > 0) {
        list = generateData(res.result, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }
      setLoading(false);

      return {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res.result.totalCount,
      };
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    const allValuesNull = newFilters.every(
      (item) => item.value === null || (item?.value?.start === null && item?.value?.end === null),
    );
    if (allValuesNull) {
      callChangeFilter(newFilters);
      return;
    }
    let copyTemp = [...newFilters];
    if (
      copyTemp[0].value === null &&
      copyTemp[1].value.start === null &&
      copyTemp[1].value.end === null
    ) {
      setFilters(copyTemp);
      callChangeFilter(copyTemp);
    } else if (newFilters[0]?.value === null) {
      copyTemp[0].value = null;
      copyTemp[1].value.start = null;
      copyTemp[1].value.end = null;

      callChangeFilter(copyTemp);
      createToast('خطا', 'جهت اعمال محدوده تاریخ ، می بایست نوع تاریخ انتخاب شود.', 'warning');
      return;
    } else if (newFilters[0].value !== null) {
      if (copyTemp[1].value.start === null || copyTemp[1].value.end === null) {
        copyTemp[0].value = null;
        copyTemp[1].value.start = null;
        copyTemp[1].value.end = null;
        createToast(
          'خطا',
          'در صورت انتخاب نوع تاریخ ، محدوده تاریخ می بایست انتخاب شود.',
          'warning',
        );
        callChangeFilter(copyTemp);
        return;
      } else {
        callChangeFilter(newFilters);
      }
    } else {
      callChangeFilter(newFilters);
    }
  };

  const callChangeFilter = (newFilters) => {
    setPage(0);
    setSize(50);
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100);
    setFilters(newFilters);
  };

  // const onExport = (type, index) => {
  //   const types = ['xls', 'csv'];
  //   downloadFile(types[index], filterParams?.data, filterParams?.params);
  // };

  const onTransfer = (targetDelegation) => {
    if (!targetDelegation) return;
    if (targetDelegation?.status?.includes('غیر')) {
      return createToast('خطا', 'امکان انتقال اعتبار غیر فعال وجود ندارد.', 'danger');
    }
    setTargetTransferDelegation(targetDelegation);
    setIsTransferOpen(true);
  };

  const putDefault = async (delegationId) => {
    if (!delegationId) return;
    try {
      const result = await putDefaultList(delegationId);
      setPage(0);
      setSize(50);
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100);
    } catch (error) {}
  };

  const onResetTransfer = () => {
    setIsTransferOpen(false);
    setTargetTransferDelegation(null);
  };

  return (
    <>
      <Grid item xs={12}>
        <Box display="flex" justifyContent="end" alignItems="flex-end" style={{ marginBottom: 16 }}>
          {actionsList['selfAccountDelegationPage'] && (
            <FilterButton setOpenFilterDialog={setOpenFilterDialog} filters={filters} />
          )}
          {actionsList['exportAccountDelegationBtn'] && (
            <ReceiveFile
              type={'delegation'}
              paramsData={paramsData}
              allowedTypesFormat={['CSV', 'XLS']}
              isFormatExport={true}
            />
          )}
        </Box>
        {actionsList['selfAccountDelegationPage'] && (
          <Box>
            <FilterPod
              filters={filters}
              onChange={onFiltersChange}
              openFilterDialog={openFilterDialog}
              setOpenFilterDialog={setOpenFilterDialog}
              handleCloseFilterDialog={handleCloseFilterDialog}
            />
          </Box>
        )}
      </Grid>
      {actionsList['selfAccountDelegationPage'] && businessInfo?.userId && currencyText && (
        <TableReport
          data={getDelegations}
          columns={columns(
            setActiveDetailID,
            onTransfer,
            putDefault,
            actionsList,
            classes,
            setShowDialog,
            setDataDialog,
            currencyText,
          )}
          isLoading={loading}
          ref={tableRef}
          onChange={(ps) => {
            setPage(ps?.pageNumber);
            setSize(ps?.pageSize);
            return getDelegations(ps);
          }}
        />
      )}
      <SimpleDialog
        fullWidth
        maxWidth="md"
        open={showDialog}
        title={'جزئیات اعتبار تخصیص داده شده'}
        onClose={() => setShowDialog(false)}
      >
        <DetailPanel delegationId={dataDialog?.delegationId} />
      </SimpleDialog>
      <SimpleDialog
        fullWidth
        maxWidth="md"
        open={activeDetailID !== null}
        title="گزارش مصرف اعتبار دریافتی"
        onClose={() => setActiveDetailID(null)}
      >
        <DelegationDetails delegationId={activeDetailID} currencyText={currencyText} />
      </SimpleDialog>
      <SimpleDialog
        open={isTransferOpen}
        title="انتقال وجه تفویض شده به کاربر دیگر"
        onClose={onResetTransfer}
      >
        <TransferDelegation
          targetDelegation={targetTransferDelegation}
          onCancel={onResetTransfer}
          currencyText={currencyText}
        />
      </SimpleDialog>
    </>
  );
};
